import {
  addNode,
  addEdge,
  removeNode,
  removeEdge,
  updateEdge,
} from '../../features/networkUndoSlice';
import {
  setHighlightedNodes,
  setHighlightedEdges,
} from '../../features/networkSlice';

export const handleDelete = (event, dispatch) => {
  if (event.nodes.length > 0) {
    dispatch(removeNode(event.nodes[0]));
  } else if (event.edges.length > 0) {
    const edgeId = event.edges[0];
    dispatch(removeEdge(edgeId));
  }
  dispatch(setHighlightedEdges([]));
  dispatch(setHighlightedNodes([]));
};

export const handleNewNode = (event, dispatch, nodeId) => {
  const node = {
    id: nodeId,
    label: `${nodeId}`,
    x: Math.round(event.pointer.canvas.x / 50) * 50,
    y: Math.round(event.pointer.canvas.y / 50) * 50,
    // physics: false,
  };
  dispatch(addNode(node));
};

// TODO: refactor (too many arguments)
export const handleNewEdge = (dispatch, tool, newEdge, edges) => {
  if (newEdge && ['edgePos', 'edgeNeg'].includes(tool)) {
    const type = tool === 'edgePos' ? 'triangle' : 'circle';
    const edge = {
      id: edges.max('id') ? edges.max('id').id + 1 : 1, // ID is required
      from: newEdge.from,
      to: newEdge.to,
      arrows: { to: { type } },
    };

    // prevent duplicates
    const duplicateEdges = edges.get({
      filter: (item) => (
        item.to === newEdge.to
        && item.from === newEdge.from
        // && item.arrows.to.type === type
      ),
    });

    // add unless duplicate
    if (duplicateEdges.length === 0) {
      dispatch(addEdge(edge));
    } else {
      edge.id = duplicateEdges[0].id;
      dispatch(updateEdge(edge));
    }
  }
};

export default {};
